module.exports = __webpack_public_path__ + "static/img/redBoxb.f064554.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/redBoxb.png
// module id = iTPI
// module chunks = 1